import { WHITE_LABEL_CONFIG } from "@/src_new/whiteLabel";
import type {
  WhiteLabelComponentClasses,
  WhiteLabelTheme,
} from "@/src_new/whiteLabel/shared/theme";

export function getTheme(): WhiteLabelTheme {
  return WHITE_LABEL_CONFIG.theme;
}

export function getThemeComponentClasses(): WhiteLabelComponentClasses {
  return getTheme().componentClasses;
}

export function getThemeComponentGroup<K extends keyof WhiteLabelComponentClasses>(
  groupName: K
): WhiteLabelComponentClasses[K] {
  return getThemeComponentClasses()[groupName];
}

export function getThemeClass(value: string | undefined, fallback: string): string {
  return value || fallback;
}
